module.exports = __webpack_public_path__ + "img/C5.b82bc5db.webp";